// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordinal_qiOOg {
  height: 22px;
}

.locatorError_xv2xy {
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/resultRenderers/Shared.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ordinal {\n  height: 22px;\n}\n\n.locatorError {\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ordinal": `ordinal_qiOOg`,
	"locatorError": `locatorError_xv2xy`
};
export default ___CSS_LOADER_EXPORT___;
